import { render, staticRenderFns } from "./TestComponent.vue?vue&type=template&id=17c91a40&scoped=true&"
import script from "./TestComponent.vue?vue&type=script&lang=ts&"
export * from "./TestComponent.vue?vue&type=script&lang=ts&"
import style0 from "./TestComponent.vue?vue&type=style&index=0&id=17c91a40&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17c91a40",
  null
  
)

export default component.exports